import cn from "classnames";
import React from "react";
import styles from "./icon-button.css";

export interface IconButtonProps {
    ["aria-label"]: string;
    className?: string;
    icon: JSX.Element;
    onClick?(): void;
}

export function IconButton({ icon, onClick, className, ...props }: IconButtonProps): JSX.Element {
    return (
        <button
            aria-label={props["aria-label"]}
            onClick={onClick}
            className={cn(styles.button, className)}
            type="button"
        >
            {icon}
        </button>
    );
}
